import {
  loserPositionMap,
  losersPointsMap,
  matchNumberMapping,
  registrationPointsMap,
  tournamentStageMap,
  winnerPoints,
  winnerPositionMap,
} from 'constants/Tournament';

export const CurrentWinnersPosition = (
  winner,
  challenger_id,
  challenger_position,
  opponent_id,
  opponent_position,
) => {
  if (winner === challenger_id) {
    return challenger_position;
  } else if (winner === opponent_id) {
    return opponent_position;
  } else {
    return null;
  }
};

export const CurrentLosersPosition = (
  loser,
  challenger_id,
  challenger_position,
  opponent_id,
  opponent_position,
) => {
  if (loser === challenger_id) {
    return challenger_position;
  } else if (loser === opponent_id) {
    return opponent_position;
  } else {
    return null;
  }
};

export const NextWinnerPosition = (position) => {
  return winnerPositionMap[position];
};

export const NextLoserPosition = (position) => {
  return loserPositionMap[position];
};

export const checkWinnersPoints = (
  match_number,
  tournament_stage,
  tournament_level,
) => {
  const stagePoints = winnerPoints[tournament_stage];
  if (!stagePoints) return 0;

  const levelPoints = stagePoints[tournament_level];
  if (!levelPoints) return 0;

  if (typeof levelPoints === 'number') {
    return levelPoints;
  } else {
    return levelPoints[match_number] || levelPoints.default || 0;
  }
};

export const checkLosersPoints = (
  match_number,
  tournament_stage,
  tournament_level,
) => {
  const stagePoints = losersPointsMap[tournament_stage];
  if (!stagePoints) return 0;

  if (typeof stagePoints === 'number') {
    return stagePoints;
  } else {
    const levelPoints = stagePoints[tournament_level];
    if (!levelPoints) return 0;

    return levelPoints[match_number] || levelPoints.default || 0;
  }
};

export const checkRegistrationPoints = (tournament_level) => {
  return registrationPointsMap[tournament_level] || 0;
};

export const getPersonRanking = (points, userId) => {
  let rank = '';
  const sortedPoints = points.sort(
    (a, b) => b.tournament_points - a.tournament_points,
  );
  const userIndex = sortedPoints.findIndex(
    (player) => player.id === Number(userId),
  );
  rank = userIndex + 1;

  return rank;
};

export const tournamentStage = (tournament_stage, match_number) => {
  const stage = tournamentStageMap[tournament_stage];
  if (typeof stage === 'string') {
    return stage;
  } else {
    return stage ? stage[match_number] : undefined;
  }
};

export const playoffsWinner = (match_number) => {
  return matchNumberMapping[match_number]?.winner || '';
};

export const upcomingMatch = (match_number) => {
  return matchNumberMapping[match_number]?.nextMatch;
};

export const nextGroup = (match_number) => {
  return matchNumberMapping[match_number]?.nextGroup;
};

export const playoffPairs = {
  P1: [
    'T1',
    'T2',
    'T3',
    'T4',
    'T5',
    'T6',
    'T7',
    'T8',
    'T9',
    'T10',
    'T11',
    'T12',
    'T13',
    'T14',
    'T15',
    'T16',
    'T17',
    'T18',
    'T19',
    'T20',
    'T21',
    'T22',
    'T23',
    'T24',
    'T25',
    'T26',
    'T27',
    'T28',
    'T29',
    'T30',
    'T31',
    'T32',
    'T33',
    'T34',
    'T35',
    'T36',
    'T37',
    'T38',
    'T39',
    'T40',
    'T41',
    'T42',
    'T43',
    'T44',
    'T45',
    'T46',
    'T47',
    'T48',
    'T49',
    'T50',
    'T51',
    'T52',
    'T53',
    'T54',
    'T55',
    'T56',
    'T57',
    'T58',
    'T59',
    'T60',
    'T61',
    'T62',
    'T63',
    'T64',
  ],
  P2: [
    'S1',
    'S2',
    'S3',
    'S4',
    'S5',
    'S6',
    'S7',
    'S8',
    'S9',
    'S10',
    'S11',
    'S12',
    'S13',
    'S14',
    'S15',
    'S16',
    'S17',
    'S18',
    'S19',
    'S20',
    'S21',
    'S22',
    'S23',
    'S24',
    'S25',
    'S26',
    'S27',
    'S28',
    'S29',
    'S30',
    'S31',
    'S32',
  ],
  P3: [
    'A1',
    'A2',
    'A3',
    'A4',
    'A5',
    'A6',
    'A7',
    'A8',
    'A9',
    'A10',
    'A11',
    'A12',
    'A13',
    'A14',
    'A15',
    'A16',
  ],
  P4: ['K1', 'K2', 'K3', 'K4', 'K5', 'K6', 'K7', 'K8'],
  P5: ['PF1', 'PF2', 'PF3', 'PF4'],
  P6: ['F1', 'F2'],
  P7: ['F3', 'F4'],
};

// Automatically pair in order, every 2 elements
export const getPlayoffPairs = () => {
  const pairs = [];
  for (const [key, values] of Object.entries(playoffPairs)) {
    for (let i = 0; i < values.length; i += 2) {
      pairs.push({
        matchKey: key,
        group1: values[i],
        group2: values[i + 1],
      });
    }
  }
  return pairs;
};

export const playoffProgression = {
  P1: 'P2',
  P2: 'P3',
  P3: 'P4',
  P4: 'P5',
  P5: 'P6',
  P6: null, // final → no next
  P7: null, // 3rd place → no next
};
